module.exports = __webpack_public_path__ + "static/img/cyx2.8804dbe8.png";